module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BasePage', {
    attrs: {
      "title": "Group"
    }
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-8-desktop is-offset-2-desktop"
  }, [(!_vm.loadingTeamData && _vm.team) ? _c('section', [_c('div', {
    staticClass: "header is-right"
  }, [_c('nav', {
    staticClass: "level"
  }, [(!_vm.editing) ? _c('div', {
    staticClass: "level-item justify-content-start align-items-center"
  }, [_c('h1', {
    staticClass: "title is-1"
  }, [_vm._v(_vm._s(_vm.team != null ? _vm.team.name : 'Group'))]), _vm._v(" "), (_vm.team.privacy_setting) ? _c('span', {
    staticClass: "tag is-medium spaced",
    class: {
      'is-primary': _vm.public,
      'is-warning': _vm.closed,
      'is-danger': _vm.private
    }
  }, [_vm._v(_vm._s(_vm.privacySettingLabel))]) : _vm._e(), _vm._v(" "), (_vm.isModerator) ? _c('a', {
    staticClass: "button is-link",
    on: {
      "click": function($event) {
        _vm.editing = true
      }
    }
  }, [_vm._v("edit")]) : _vm._e()]) : _c('div', {
    staticClass: "level-item justify-content-start align-items-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editedName),
      expression: "editedName"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Group Name"
    },
    domProps: {
      "value": (_vm.editedName)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.save($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.editedName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "select ml-1"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editedPrivacySetting),
      expression: "editedPrivacySetting"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.editedPrivacySetting = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.privacy), function(name) {
    return _c('option', {
      domProps: {
        "value": name
      }
    }, [_vm._v(_vm._s(name == 'public' ? 'open' : name))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "buttons d-flex ml-1"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.editing = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "button is-primary",
    class: _vm.loading && 'is-loading',
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")])])]), _vm._v(" "), _c('div', {
    staticClass: "level-item has-text-centered"
  }, [_c('div', [_c('p', {
    staticClass: "heading"
  }, [_vm._v("Members")]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.team.members.length))])])]), _vm._v(" "), _c('div', {
    staticClass: "level-item has-text-centered"
  }, [_c('div', [_c('p', {
    staticClass: "heading"
  }, [_vm._v("Videos")]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.videos.length))])])])])])]) : _vm._e(), _vm._v(" "), (_vm.loadingTeamData) ? _c('Loader', {
    staticClass: "flex-start"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tabs is-boxed"
  }, [_c('ul', [_c('li', {
    class: _vm.activeTab === 'videos' && 'is-active'
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.activeTab = 'videos'
      }
    }
  }, [_c('span', [_vm._v("Videos")])])]), _vm._v(" "), _c('li', {
    class: _vm.activeTab === 'members' && 'is-active'
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.activeTab = 'members'
      }
    }
  }, [_c('span', [_vm._v("Members")])])]), _vm._v(" "), _c('li', {
    class: _vm.activeTab === 'data' && 'is-active'
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.activeTab = 'data'
      }
    }
  }, [_c('span', [_vm._v("Data")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-tablet"
  }, [(_vm.activeTab === 'videos') ? _c('div', {
    staticClass: "column"
  }, [_c('section', {
    staticClass: "box"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("Shared Videos")]), _vm._v(" "), _c('section', [(_vm.videos != null && _vm.videos.length > 0) ? _c('ul', _vm._l((_vm.videos), function(ts) {
    return _c('article', {
      staticClass: "media"
    }, [_c('router-link', {
      attrs: {
        "to": '/videos/' + ts.video.id + '/'
      }
    }, [_c('figure', {
      staticClass: "media-left"
    }, [_c('p', {
      staticClass: "image is-64x64"
    }, [_c('img', {
      attrs: {
        "src": ts.video.user.avatar_url
      }
    })])])]), _vm._v(" "), _c('router-link', {
      attrs: {
        "to": '/videos/' + ts.video.id + '/'
      }
    }, [_c('div', {
      staticClass: "media-content"
    }, [_c('div', {
      staticClass: "content"
    }, [_c('p', [_c('strong', [_vm._v(_vm._s(ts.video.user.name || ts.video.user.email))]), _vm._v(" shared the video "), _c('strong', [_c('em', [_vm._v(_vm._s(ts.video.title))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v("Shared on " + _vm._s(_vm._f("formatTextDate")(ts.created_on)))])])])])])], 1)
  })) : _c('p', [_vm._v("No shared videos.")])])])]) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'members') ? _c('div', {
    staticClass: "column"
  }, [(!_vm.loadingTeamData && _vm.isModerator) ? _c('GroupModeratorPane', {
    attrs: {
      "teamID": _vm.team.id
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('section', {
    staticClass: "column is-8 box"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("Members")]), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loadingTeamData),
      expression: "!loadingTeamData"
    }]
  }, [(_vm.team != null && _vm.team.members != null && _vm.team.members.length > 0) ? _c('ul', _vm._l((_vm.team.members), function(member) {
    return _c('li', {
      staticClass: "panel-block"
    }, [_c('p', {
      staticClass: "break-word"
    }, [_vm._v("\n                      " + _vm._s(member.name || member.email)), (member.is_coach) ? _c('span', {
      staticClass: "tag is-rounded is-primary"
    }, [_vm._v("Coach")]) : _vm._e(), (member.is_group_admin) ? _c('span', {
      staticClass: "tag is-rounded is-warning"
    }, [_vm._v("Admin")]) : _vm._e(), _vm._v(" "), (_vm.user.id === member.id) ? _c('span', {
      staticClass: "tag"
    }, [_vm._v("You")]) : _vm._e(), _vm._v(" "), (_vm.isModerator) ? _c('input', {
      staticClass: "button is-small is-danger is-right",
      attrs: {
        "type": "button",
        "value": "remove",
        "name": "remove"
      },
      on: {
        "click": function($event) {
          _vm.removeUser(member.id)
        }
      }
    }) : _vm._e()])])
  })) : _c('p', [_vm._v("No members.")])]), _vm._v(" "), (_vm.loadingTeamData) ? _c('Loader') : _vm._e()], 1), _vm._v(" "), _c('section', {
    staticClass: "column is-6 box"
  }, [(!_vm.loadingTeamData && _vm.isModerator) ? _c('GroupUserSearch', {
    attrs: {
      "team": this.team
    }
  }) : _vm._e()], 1)])], 1) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'data') ? _c('div', [_c('DataPane', {
    attrs: {
      "name": "Brad",
      "data": _vm.team.userdata
    }
  })], 1) : _vm._e()])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-c8b735c2"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Team.vue
// module id = 1084
// module chunks = 0